<mat-icon>search</mat-icon>

<mat-form-field subscriptSizing="dynamic">
    <input matInput [(ngModel)]="searchTerm" (ngModelChange)="ngOnChange($event)" [placeholder]="placeholder" />
    <button *ngIf="searchTerm" 
            matTextSuffix
            mat-icon-button
            class="search-clear-button"
            aria-label="Clear"
            (click)="clearSearch()">
        <mat-icon>close</mat-icon>
    </button>
</mat-form-field>
